import React, { Component } from "react";
import TextBox from "./TextBox";
import CheckBox from "./CheckBox";
import RadioButton from "./RadioButton";
import DropDown from "./DropDown";
import './InitialFormStyleSheet.css';
import InitialFormHeader from "./InitialFormHeader";

class InitialFormDetails extends Component {

    constructor(props) {
        super(props);

        this.items = this.props.config && this.props.config.form ?
            this.props.config.form.sort((i1, i2) => { return i1.selposition - i2.selposition }) : []

        // If the form has text inputs, the submit button stays disabled until
        // they are validated. Forms without text inputs are allowed to submit.
        const hasTextBox = this.items.some((item) => item.seltype !== "checkBox" && item.seltype !== "dropDown" && item.seltype !== "radioButton");

        this.state = {
            startIndex : 0,
            error: null,
            count:0,
            enableButton:true, //check if items has checkbox then make it false else true
            allowSubmit: !hasTextBox
        }

        this.components = this.items.map((item,index) => {
            const ref = React.createRef();
            if      (item.seltype === "checkBox")    { return { item, ref, component: <CheckBox    idxx={'chh'+index}              ref={ref} item={item} key={item.selposition}  setEnableButton={(data)=>this.setState({enableButton:data}) }/> }}
            else if (item.seltype === "dropDown")    { return { item, ref, component: <DropDown    idxx={'ch'+index}               ref={ref} item={item} key={item.selposition} /> }}
            else if (item.seltype === "radioButton") { return { item, ref, component: <RadioButton ref={ref} item={item}           key={item.selposition} /> }}
            else                   /* 'txtBox' */    { return { item, ref, component: <TextBox        idxx={'txt'+index}     {...this.props}   index={index}      ref={ref} item={item} key={item.selposition} count={this.state.count} modifyLoginButton={this.modifyLoginButton}  /> }}
        })
    }

    modifyLoginButton = (data) => {
        this.setState({ allowSubmit: data });
    }

    callback = (index) =>{
      
        this.setState({startIndex:this.state.startIndex+index})
        // console.log("cback",this.state.startIndex,"index",index)
    }

    render() {
        // Sort form items by selposition.
        return (
            <>
                
                <InitialFormHeader    {...this.props}  />
                {/* <div className="s360-initial-form-sub-header-message" style={this.subHeaderStyle()}>{this.props.config.configDetails.brandSubMessage}</div> */}

                <div className="s360-initial-form-details-container" style={this.containerStyle()}>
                    <div className="s360-initial-form-details-inputs">
                        {this.components.map((component) => <>{component.component}</>)}
                    </div>
                    <div className={"s360-initial-form-start-button-container"}>
                        <button
                            className="s360-initial-form-start-button"
                            onClick={this.startChat}
                            style={this.buttonStyle()}
                            disabled={!(this.state?.enableButton && this.state?.allowSubmit)}
                        >
                            <span className="s360-initial-form-start-button-span-text">{this.props.config.designDetails.formButtonText}</span>
                        </button>
                    </div>
                </div>
            </>
        );

    }
    // subHeaderStyle = () => {
    //     return {
    //         color:      this.props.config.designDetails.subHeaderFontColor,
    //         fontFamily: this.props.config.designDetails.subHeaderFont,
    //         fontSize:   this.props.config.designDetails.subHeaderFontSize,
    //     }
    //     }

    containerStyle = () => {
        return {
            backgroundColor: this.props.config.designDetails.pageBackgroundColor
        }
    }

    buttonStyle = () => {
        return {
            background: this.props.config.designDetails.formButtonBackground,
            color:      this.props.config.designDetails.formButtonColor,
            fontFamily:     this.props.config.designDetails.selectionButtonFont,
            fontSize:       this.props.config.designDetails.selectionButtonFontSize+"px",
        }
    }

    buttonStyleNew = () => {
        return {
            background: this.props.config.designDetails.formButtonBackground,
            color:      this.props.config.designDetails.formButtonColor,
            fontFamily:     this.props.config.designDetails.selectionButtonFont,
            fontSize:       this.props.config.designDetails.selectionButtonFontSize+"px",
            display:"inline-block",
            width:"35%"
        }
    }

    startChat = () => {
        // TODO: Add validations for fields.
        
        let invalidOptions = this.components.filter(component => { return !component.ref.current.validate() });
        
        const isValid = invalidOptions.length === 0;
        if (isValid) {
            let params = {};
            this.components.forEach(component => params = { ...params, ...component.ref.current.value() });
            this.props.actions.startChat(params);
        } else if (invalidOptions.length > 0) {
           
            let errorMessage = invalidOptions[0].ref.current.validationErrorMessage();
          //this.props.actions.showPopUpMessage(errorMessage);
            invalidOptions[0].ref.current.focus = true;
            
            
            this.setState({...this.state,error:errorMessage,count:this.state.count+1})
        }
    }

}
export default InitialFormDetails;